module.exports = __webpack_public_path__ + "img/golf-ball.a6f330a0.svg";